export const DebugPanelSize = {
  minSize: 360,
  maxSize: 800,
  defaultSize: 450,
} as const;

export const SidebarPanelSize = {
  minSize: 120,
  maxSize: 600,
  defaultSize: 320,
} as const;

export const ContentPanelSize = {
  minSize: 520,
} as const;

export enum ScreenSize {
  /**
   * 1，移动端
   */
  Mobile = 1,

  /**
   * 800，sidebar 常显示，debug 从底部弹出
   */
  OnlySidebar = SidebarPanelSize.minSize + ContentPanelSize.minSize,

  /**
   * 880，sidebar 常显示，debug 显示的时候，隐藏 sidebar
   */
  AutoSidebar = ContentPanelSize.minSize + DebugPanelSize.minSize,

  /**
   * 1160px，sidebar 和 debug 都显示但是不能调整大小
   */
  ThreeColumn = SidebarPanelSize.minSize + ContentPanelSize.minSize + DebugPanelSize.minSize,

  /**
   * 1560px，整体居中，sidebar 和 debug 都可以调整尺寸
   */
  MaxContent = 1560,
}
